import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Container, Row, Col } from "react-bootstrap";
import { BrowserView, MobileView } from "react-device-detect";
import chart from "../../../images/emasters/chart.png";
import chartMob from "../../../images/emasters/chart-mob.png";
import { AnimatedLine } from "../../common/designParts/animatedUnderline";

export const EmasterFlow = () => {
  return (
    <div style={{backgroundColor:"#F8F8F8"}} id="process">  
    <Container className="emastercontainer pt-3 mt-1">
      <Row>
        <Col md={12}>
          <ScrollAnimation
            animateIn="animate-text"
            duration={5}
            animateOnce={true}
          >
            <h2 className="h2heading1">
              Our Process
              <span className="bold"> Flow</span>
            </h2>
          </ScrollAnimation>
          <AnimatedLine
            className="animateline"
            width={"130px"}
            margin={"0px 0 10px 0"}
          >
            <ScrollAnimation
              animateIn="fadeInLeft"
              duration={2}
              animateOnce={true}
              className="no-animation"
            >
              <div className="line"></div>
            </ScrollAnimation>
          </AnimatedLine>

          <div className="emaster-flow-chart">
            <BrowserView>
              <img src={chart} alt="" />
            </BrowserView>
            <MobileView>
              <img src={chartMob} alt="" />
            </MobileView>
          </div>
        </Col>
      </Row>
    </Container>
    </div>
  );
};
